import React, { useEffect, useState } from 'react';
import Form from '../components/Form/Form';
import Swal from 'sweetalert2';
import { useContext } from 'react';
import AuthContext from '../store/auth-context';

const ContactFormContent = () => {
  return (
    <React.Fragment>
      <div className='main-screen__content-header '>
        <h4 className='me-5'>What's next?</h4>
        <h2>
          <span className='highlight'>&#91;</span>Get In Touch
          <span className='highlight'>&#93;</span>
        </h2>
      </div>

      <p className='main-screen__content-main'>
        <span className='highlight'>Currently</span> looking for any
        <span className='highlight'>&nbsp; opportunities</span>. Whether you
        have a <span className='highlight'>&nbsp;question</span> or just want to
        say hi . Drop a message and I'll get back to you as soon as possible.
      </p>
    </React.Fragment>
  );
};

const ContactFormHandler = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState({
    error: false,
    message: '',
  });
  // const [isFormValid, setIsFormValid] = useState({
  //   name: false,
  //   email: false,
  //   number: false,
  //   message: false,
  // });

  const nameChangeHandler = (event) => {
    setName(event);
  };

  const numberChangeHandler = (event) => {
    setNumber(event);
  };

  const emailChangeHandler = (event) => {
    setEmail(event);
  };

  const messageChangeHandler = (event) => {
    setMessage(event);
  };

  // const validateNameHandler = () => {
  //   name.trim().length > 0 &&
  //     setIsFormValid((prev) => ({ ...prev, name: true }));
  // };

  // useEffect(() => {
  //   console.log(isFormValid);
  // }, [isFormValid]);

  const sendEmail = (e) => {
    e.preventDefault();

    if (
      name.trim().length === 0 ||
      email.trim().length === 0 ||
      number.trim().length === 0 ||
      message.trim().length === 0
    ) {
      setError({
        error: true,
        message: 'Fields cannot be empty',
      });
      return;
    } else {
      setError({
        error: false,
      });
    }

    if (number.length < 10) {
      setError({
        error: true,
        message: 'Please enter a valid number',
      });
      return;
    } else {
      setError({
        error: false,
      });
    }

    if (!error.error) {
      fetch('https://aifolio-api.herokuapp.com/api/user/email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          name: name,
          number: number,
          sender_message: message,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            Swal.fire({
              title: data.message,
              icon: 'success',
              showConfirmButton: false,
              timer: 1200,
            });

            setName('');
            setEmail('');
            setNumber('');
            setMessage('');

            window.scrollTo(0, 0);
          } else {
            Swal.fire({
              title: data.message.message,
              icon: 'error',
              showConfirmButton: false,
              timer: 1200,
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            title: err.message.message,
            icon: 'error',
            showConfirmButton: false,
            timer: 1200,
          });
        });
    }
  };

  useEffect(() => {
    if (error.error) {
      Swal.fire({
        title: error.message,
        icon: 'error',
        showConfirmButton: false,
        timer: 1200,
      });
    }
  }, [error]);

  return (
    <Form
      nameChangeHandler={nameChangeHandler}
      numberChangeHandler={numberChangeHandler}
      emailChangeHandler={emailChangeHandler}
      messageChangeHandler={messageChangeHandler}
      sendEmail={sendEmail}
      email={email}
      name={name}
      number={number}
      message={message}
      // validateNameHandler={validateNameHandler}
    />
  );
};

const Contact = () => {
  const context = useContext(AuthContext);

  useEffect(() => {
    context.pathnameHandler(window.location.pathname);
  });

  return (
    <div
      className={`main-screen__content  ${
        context.pathname === '/contact' ? 'show-section' : ''
      }`}
    >
      <ContactFormContent />
      <ContactFormHandler />
    </div>
  );
};

export default Contact;
